if (!customElements.get('meta-slider')) {
  class MetaSlider extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.options = {
        draggable: true,
        slidesPerView: 'auto',
        slidesPerGroup: 1,
        spaceBetween: 10,
        navigation: {
          nextEl: this.closest('section').querySelector('.swiper-button-next'),
          prevEl: this.closest('section').querySelector('.swiper-button-prev'),
        },
      };

      this.scrollBar = this.querySelector('.swiper-scrollbar');

      if (this.scrollBar) {
        this.options.scrollbar = { el: this.scrollBar, draggable: true };
      }

      this.slider = new Swiper(this.querySelector('.swiper'), this.options);
    }
  }

  customElements.define('meta-slider', MetaSlider);
}
